exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".privacyAgreementBody[data-v-9401608c] {\n  width: 100%;\n  min-height: 0px;\n}\n.privacyAgreementBody .contentBox[data-v-9401608c] {\n  width: 100%;\n  font-size: 14px;\n}\n.privacyAgreementBody .contentBox .contentTitle[data-v-9401608c] {\n  margin-top: 15px;\n  line-height: 26px;\n  color: #333;\n  font-weight: bold;\n  word-break: keep-all;\n}\n.privacyAgreementBody .contentBox .contentInner[data-v-9401608c] {\n  margin-top: 5px;\n  line-height: 24px;\n  color: #777;\n}\n", ""]);

// exports
